var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4v-.5C4 2.7 3.3 2 2.5 2S1 2.7 1 3.5V10h5.5C7.3 10 8 9.4 8 8.5 8 7.7 7.3 7 6.5 7h-1c1.1-1.8 3.1-3 5.4-3 3.4 0 6.2 2.7 6.2 6s-2.7 6-6.2 6c-1.8 0-3.5-.8-4.6-2-.6-.6-1.5-.7-2.1-.1-.7.6-.8 1.5-.2 2.1 1.7 1.8 4.1 3 6.8 3 5 0 9.2-4 9.2-9s-4.1-9-9.2-9C8.1 1 5.7 2.1 4 4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .3.1.5.3.7l2 2c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L12 9.6V6z"
  })));
};
export default SvgHistory;